module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vgal8-df3ebdfe47bf546e5d99229694f0bca1.jpg";